import React from 'react';
import { Plus } from 'lucide-react';

/** Dashed "+" tile used to add a meal type or option row. */
export default function MealSlotAddButton({ onClick, title, className = '' }) {
  return (
    <div className={`flex justify-start pt-6 ${className}`.trim()}>
      <button
        type="button"
        onClick={onClick}
        className="flex items-center justify-center w-32 h-40 border-2 border-dashed border-gray-300 rounded-lg hover:border-orange-primary hover:bg-orange-50 transition-colors cursor-pointer focus:outline-none focus:ring-0"
        title={title}
      >
        <Plus className="w-6 h-6 text-gray-400 hover:text-orange-primary" />
      </button>
    </div>
  );
}
